<template>
  <div :class="classes()">
    <AuthScreen>
      <FormBox
        slot="formBox"
        :headline="!sent ? $t('auth.forgotPassword.form.headline') : ''"
        :copy="!sent ? $t('auth.forgotPassword.form.copy') : ''"
      >
        <template slot="form">
          <transition name="fade">
            <div v-if="sent" :class="`${el}__done`">
              <Icon name="mail-send-fill" color="supportSuccess" :class="`${el}__doneIcon`" />
              <Headline size="s" responsive centered noMargin>
                {{ $t('auth.forgotPassword.form.done') }}
              </Headline>
              <Copy color="tertiaryLight" size="m" v-html="$t('auth.spam.copy')" />
            </div>
          </transition>
          <ForgotPasswordForm v-if="!sent" @sent="setSent" />
        </template>

        <Link slot="bottom" :to="ROUTE_LOGIN" :onClick="() => trackClick('backwardLink', 'S2')">
          {{ $t('auth.forgotPassword.form.back') }}
        </Link>
      </FormBox>
    </AuthScreen>
  </div>
</template>

<script>
import Link from '@/objects/Link';
import Headline from '@/objects/Headline';
import Copy from '@/objects/Copy';
import Icon from '@/objects/Icon';
import ForgotPasswordForm from '@/components/Forms/ForgotPasswordForm';
import FormBox from '@/components/FormBox';
import AuthScreen from '@/components/AuthScreen';

import { ROUTE_LOGIN } from '@/constants/routes';

import { createTrackingData } from '@/helpers/tracking/utils/helpers';

export default {
  name: 'ForgotPassword',
  props: {},
  components: {
    Link,
    Headline,
    Copy,
    Icon,
    ForgotPasswordForm,
    FormBox,
    AuthScreen,
  },
  data() {
    return {
      sent: false,
      ROUTE_LOGIN,
      el: 'v-forgotPassword',
      classes: () => {
        const el = this.el;
        return {
          [el]: true,
        };
      },
    };
  },

  methods: {
    setSent() {
      this.sent = true;
      this.trackClick('forwardBtn');
    },

    trackClick(clickedElement, page = null) {
      let labelText = 'PW-vergessen-';
      let eventText = '';

      if (this.sent && page === 'S2') {
        labelText = labelText + page + '_';
      } else {
        labelText = labelText + 'S1_';
      }

      switch (clickedElement) {
        case 'backwardLink':
          eventText = 'link';
          labelText = labelText + 'link-' + this.$t('auth.forgotPassword.form.back');
          break;
        case 'forwardBtn':
          eventText = 'button';
          labelText = labelText + 'btn-' + this.$t('auth.forgotPassword.form.button');
          break;
      }

      createTrackingData('Anmelden', labelText, eventText);
    },
  },
};
</script>
